import { MaskitoPlugin } from '@maskito/core';
import { maskitoEventHandler } from '@maskito/kit';

import { dropFloatingDecimalSymbolPostprocessor } from '../processors';

const DUMMY_SELECTION = [0, 0] as const;

/**
 * It removes floating decimal separator if no decimal numbers provided.
 * @example 1 000, => blur => 1 000
 */
export function dropFloatingDecimalSymbolPlugin(decimalSeparator: string): MaskitoPlugin {
    const dropFloatingDecimalSymbol = dropFloatingDecimalSymbolPostprocessor(decimalSeparator);

    return maskitoEventHandler(
        'blur',
        element => {
            const newValue = dropFloatingDecimalSymbol(
                {
                    value: element.value,
                    selection: DUMMY_SELECTION,
                },
                { value: '', selection: DUMMY_SELECTION },
            ).value;

            if (element.value !== newValue) {
                element.value = newValue;
                element.dispatchEvent(
                    new Event('input', {
                        bubbles: true,
                    }),
                );
            }
        },
        { capture: true },
    );
}
